import React, { useState } from 'react';
import { PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT } from '../data/product';

/** Line-art aerialist seated in a lyra, hanging from the rig (uniform stroke). */
function HoopAerialist() {
  return <g stroke="#2B1B3A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-258" data-mp="3sgcgsm44aw5w">
      <line x1="300" y1="0" x2="300" y2="92" stroke="#6B6470" strokeWidth="2" data-id="element-259" data-mp="b07p1dx3ufj" />
      <circle cx="300" cy="160" r="68" stroke="#2F6F7A" strokeWidth="5" data-id="element-260" data-mp="o1mgiuvqxiql" />
      {/* seated figure on the bottom bar, one leg extended */}
      <circle cx="292" cy="150" r="8" fill="#2B1B3A" stroke="none" data-id="element-261" data-mp="sz4fbsg1uhkv" />
      <path d="M294 160 L300 196" data-id="element-262" data-mp="f9kif395gejh" />
      <path d="M296 168 L330 120" data-id="element-263" data-mp="f8j3uosxd9x0" />
      <path d="M296 172 L262 150" data-id="element-264" data-mp="f77xqic0bq2q" />
      <path d="M300 196 L346 214" data-id="element-265" data-mp="j9uki4ttmkt2" />
      <path d="M300 196 L284 226" data-id="element-266" data-mp="j8tam3ojk4cx" />
    </g>;
}

/**
 * Shows the product mockup when it loads; if it is missing or unreachable,
 * draws the cover in code: chalk page, plum type, apparatus band, line-art aerialist.
 */
export function ProductVisual({
  className = '',
  lazy = false
}: {
  className?: string;
  lazy?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  if (PRODUCT_MOCKUP && !failed) {
    return <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} loading={lazy ? 'lazy' : undefined} referrerPolicy="no-referrer" onError={() => setFailed(true)} className={`mx-auto h-auto w-full rounded-3xl shadow-book ring-4 ring-white/10 ${className}`} data-id="element-267" data-mp="1zbf4p8vjjjxt" />;
  }
  return <div className={`relative mx-auto ${className}`} role="img" aria-label={PRODUCT_MOCKUP_ALT} data-id="element-268" data-mp="2j1s5uf9ubf4g">
      {/* the other volumes, fanned behind */}
      <div className="absolute inset-0 translate-x-[9%] translate-y-[2%] rotate-[6deg] rounded-[14px] bg-amber shadow-book" aria-hidden="true" data-id="element-269" data-mp="2x0i6u5zs5yy3" />
      <div className="absolute inset-0 translate-x-[6%] translate-y-[1.5%] rotate-[4deg] rounded-[14px] bg-teal shadow-book" aria-hidden="true" data-id="element-270" data-mp="12mqw135pt912" />
      <div className="absolute inset-0 translate-x-[3%] translate-y-[1%] rotate-[2deg] rounded-[14px] bg-coral shadow-book" aria-hidden="true" data-id="element-271" data-mp="xpgzz4ntlz49" />

      <div style={{
      containerType: 'inline-size'
    }} className="relative aspect-[4/3] overflow-hidden rounded-[14px] bg-cloud shadow-book" data-id="element-272" data-mp="32p8iwiorwgv7">
        <span className="apparatus-strip absolute inset-x-0 top-0 h-[3.2%]" aria-hidden="true" data-id="element-273" data-mp="36piq1yoaxdbn" />
        <svg viewBox="0 0 400 300" className="absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-274" data-mp="3br847n6tm73y">
          <HoopAerialist data-id="element-275" data-mp="3gorhajrs8dub" />
          {/* level dots */}
          <g transform="translate(28 246)" data-id="element-276" data-mp="3lnktm8vc1ysw">
            <circle cx="0" cy="0" r="5" fill="#E8614C" data-id="element-277" data-mp="3lm9u4l8x7d7l" />
            <circle cx="16" cy="0" r="5" fill="#E8614C" data-id="element-278" data-mp="3qeks3ik3ooxi" />
            <circle cx="32" cy="0" r="5" fill="#E6DCCD" data-id="element-279" data-mp="3qh6z9h32x2f7" />
          </g>
          <text x="28" y="276" fill="#6B6470" fontFamily="Inter, sans-serif" fontWeight="700" fontSize="11" letterSpacing="2" data-id="element-280" data-mp="3ufwme1dx5yc1">
            SILKS · HOOP · TRAPEZE
          </text>
        </svg>
        <div className="relative px-[7%] pt-[8%]" data-id="element-281" data-mp="89zqnfj4ltf1">
          <p className="font-sans text-[3cqw] font-bold uppercase tracking-[0.2em] text-coral-deep" data-id="element-282" data-mp="id4wvsghb8jt">
            A full year · 6 volumes
          </p>
          <p className="mt-[2cqw] font-display text-[9cqw] font-bold leading-[0.95] tracking-tight text-ink" data-id="element-283" data-mp="dcgyglpx7pfk">
            Aerial
            <br data-id="element-284" data-mp="8gs898zsjkvx" />
            Class Ready
          </p>
          <p className="mt-[2.4cqw] max-w-[48%] font-sans text-[3cqw] font-medium leading-snug text-slate" data-id="element-285" data-mp="4ef2ikl1nmz5">
            Done-for-you class plans, skill progressions &amp; choreography
          </p>
        </div>
      </div>
    </div>;
}